export default function Menu() {
  return <>Menu</>;
}
